"use strict";

/* tslint:disable */
/* eslint-disable */
/**
 * OpenAI API
 * APIs for sampling from and fine-tuning language models
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var _possibleConstructorReturn = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _classCallCheck = require("/Users/koelz/desk/gpt-portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = exports.BASE_PATH = void 0;
var axios_1 = require("axios");
exports.BASE_PATH = "https://api.openai.com/v1".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|"
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = function BaseAPI(configuration) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.BASE_PATH;
  var axios = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : axios_1.default;
  _classCallCheck(this, BaseAPI);
  this.basePath = basePath;
  this.axios = axios;
  if (configuration) {
    this.configuration = configuration;
    this.basePath = configuration.basePath || this.basePath;
  }
};
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /*#__PURE__*/function (_Error) {
  _inherits(RequiredError, _Error);
  function RequiredError(field, msg) {
    var _this;
    _classCallCheck(this, RequiredError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RequiredError).call(this, msg));
    _this.field = field;
    _this.name = "RequiredError";
    return _this;
  }
  return RequiredError;
}(_wrapNativeSuper(Error));
exports.RequiredError = RequiredError;